import React, { useState, useEffect } from "react";
import "./dashboard.scss";
import Header from "../landing/navbar/Header";
import { Dropdown, Modal } from "react-bootstrap";
import { Link, useHistory } from "react-router-dom";
import { CopyToClipboard } from "react-copy-to-clipboard";
import { toast } from "react-toastify";

import { Nav } from "react-bootstrap";
import Datatable from "../AllTransaction/DataTable/Datatable";
import LeadersDatatable from "./DataTableLeaders/DatatableLeaders";

import Footerline from "../landing/footer/Footerline";
import { DateRange } from "react-date-range";

import { Api_Url } from "../../utils/ApiUrl";
import axios from "axios";
import moment from "moment";
import CuurentRound from "../../hooks/dataFetchers/round";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import GetGemsStaked from "../../hooks/dataFetchers/getGemsStakedAmount";
import { useWeb3React } from "@web3-react/core";

const Dashboarddetail = ({
  tomiPrice,
  usdPrice,
  btcPrice,
  pepePrice,
  linkPrice,
  uniPrice,
  dopPrice,
  gemsPrice,
}) => {
  const { account } = useWeb3React();

  const project = localStorage.getItem("project");
  const { getGemsStaked } = GetGemsStaked();

  const { cuurentRound } = CuurentRound();

  const [activeTab, setActiveTab] = useState("link-1");

  const handleSelect = (eventKey) => {
    setActiveTab(eventKey);
  };

  const [leadersLoader, setLeadersLoader] = useState(false);

  const [agents, setAgents] = useState([]);

  const [offset, setOffset] = useState(1);
  const [limitAgents, setLimitAgents] = useState(10);

  const [count, setCount] = useState(0);

  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const tok = localStorage.getItem("accessToken");
  const history = useHistory();
  const user = JSON.parse(localStorage?.getItem("user"));
  const [showcalendar, setShowCalendar] = useState(false);
  const [alllset, setalllset] = useState("all");
  const [otherLeaders, setOtherLeaders] = useState([]);
  const [otherLeadersEarnings, setOtherLeadersEarnings] = useState([]);
  const [myTreePurchasedAmount, setMyTreePurchasedAmount] = useState([]);

  const [otherLeadersPurchasedAmount, setOtherLeadersPurchasedAmount] =
    useState([]);

  const [userselectdate, setuserselectdate] = useState(false);
  const [pc, setPC] = useState(0);
  const [pmc, setPMC] = useState(0);
  const [nrc, setNRC] = useState(0);
  const [lc, setLC] = useState(0);
  const [dpc, setDPC] = useState(0);
  const [lec, setLEC] = useState(0);
  const [a, seta] = useState(0);
  const [m, setm] = useState(0);
  const [s, sets] = useState(0);
  const [g, setg] = useState(0);
  const [gmini, setgmini] = useState(0);

  const [mm, setmm] = useState(0);
  const [ss, setss] = useState(0);
  const [gg, setgg] = useState(0);
  const [ggmini, setggmini] = useState(0);

  const [purchasesAndEarnings, setPurchasedAndEarnings] = useState([]);

  const [pee, setPEE] = useState(0);
  const [peu, setPEU] = useState(0);
  const [pet, setPET] = useState(0);

  const [totPurchases, setTotPurchases] = useState(0);
  const [dopPurchased, setDOPPurchased] = useState(0);

  const [ind, setIND] = useState(0);
  const [dt, setDT] = useState(0);
  const [totalleader, settotalleader] = useState(0);
  const [dataTime, setDataTime] = useState("");
  const [state, setState] = useState([
    {
      startDate: new Date(),
      endDate: null,
      key: "selection",
    },
  ]);
  const [adminobj, setadminobj] = useState();
  const [tokenNftStats, setTokenNftStats] = useState();
  const [activeleader, setactiveleader] = useState(0);
console.log(tokenNftStats, 'tokenNftStatstokenNftStats')
  const [specialAccess, setSpecialAccess] = useState([]);

  const [transactionApiCalled, setTransactionApiCalled] = useState(false);

  const [transactions, setTransactions] = useState([]);
  const [search, setSearch] = useState("");
  const [searchBy, setSearchBy] = useState("name");

  const [typeFilter, setTypeFilter] = useState("");
  const [orderField, setOrderField] = useState("transactionTime");
  const [orderFieldAgents, setOrderFieldAgents] = useState("directAmountInUsd");

  const [orderDirection, setOrderDirection] = useState("-1");
  const [page, setPage] = useState(0);
  const [pageCount, setPageCount] = useState(0);
  const [copy, setCopy] = useState(false);
  const [round, setRound] = useState("0");
  const [stakedAmount, setStakedAmount] = useState(0);

  const textCopiedFun2 = () => {
    setCopy(true);
    setTimeout(() => {
      setCopy(false);
    }, 1000);
  };

  const getGemsStakedAmount = async () => {
    const staked = await getGemsStaked(account);
    if (staked) {
      setStakedAmount(staked);
    }
  };

  const firstTimeData = async () => {
    try {
      let b = await cuurentRound();
      if (b) {
        setRound(b);
      }
    } catch (err) {
      // console.log(err.message, "nooor");
    }
  };

  useEffect(() => {
    if (
      account &&
      account.toLowerCase() == user?.walletAddress?.toLowerCase()
    ) {
      getGemsStakedAmount();
    }
  }, [account]);

  useEffect(() => {
    firstTimeData();
  }, []);
  useEffect(() => {
    if (usdPrice) {
      getTransactionsData();
    }
  }, [search, typeFilter, orderField, orderDirection, page, usdPrice]);

  const handlePageChange = (e) => {
    const selectedPage = e.selected;

    setPage(selectedPage);
  };

  useEffect(() => {
    if (user && activeTab == "link-2") {
      GetAgents();
    }
  }, [
    // leaderFilter,
    // roleTypeFilter,
    // roundFilter.length,
    // saleTypeFilter,
    // searchQuery,
    activeTab,
    orderFieldAgents,
    orderDirection,
    // codeBlockFilter,
    // deletedFilter,
    page,
  ]);

  const GetAgents = (filter) => {
    setAgents([]);
    setLeadersLoader(true);
    const val = localStorage.getItem("accessToken");

    var config = {
      method: "get",
      url: `${Api_Url}/users/leaders?limit=${limitAgents}&offset=${
        page + 1
      }&privateSale=${project}`,
      headers: {
        Authorization: "Bearer " + val,
      },
    };

    let dynamicQuery = config.url;
    // if (leaderFilter) {
    //   dynamicQuery += `&name=${encodeURIComponent(leaderFilter)}`;
    // }

    // if (roleTypeFilter) {
    //   dynamicQuery += `&role=${encodeURIComponent(roleTypeFilter)}`;
    // }
    // if (roundFilter?.length > 0) {
    //   dynamicQuery += `&round=${[roundFilter]}`;
    // }
    // if (saleTypeFilter) {
    //   dynamicQuery += `&salesType=${saleTypeFilter}`;
    // }
    // if (activeFilter) {
    //   dynamicQuery += `&active=${activeFilter}`;
    // }
    // if (inActiveFilter) {
    //   dynamicQuery += `&inActive=${inActiveFilter}`;
    // }

    // if (searchQuery) {
    //   dynamicQuery += `&${searchBy}=${searchQuery}`;
    // }
    if (orderFieldAgents) {
      dynamicQuery += `&orderField=${orderFieldAgents}&orderDirection=${orderDirection}`;
    }
    // if (user?.role == "god_agent") {
    //   dynamicQuery += `&myTree=${myTree}`;
    // }
    config.url = dynamicQuery;

    axios(config)
      .then(function (response) {
        const resData = response?.data?.data;
        setCount(response.data.data.count);
        setAgents(resData?.allUsersData);
        let arr = Array.from(Array(parseInt(response.data.data.pages)).keys());
        setPageCount(response.data.data.pages);
        // setPages(arr);

        setLeadersLoader(false);
      })
      .catch(function (error) {
        if (error?.response?.status == 401) {
          // localStorage.removeItem("accessToken");
          // history.push("/");
        }
        setLeadersLoader(false);
      });
  };
  const getTransactionsData = async () => {
    setTransactions([]);
    setTransactionApiCalled(false);

    var config = {
      method: "get",
      url: `${Api_Url}/users/all-transactions?limit=10&offset=${
        page + 1
      }&privateSale=${project}`,

      headers: {
        Authorization: "Bearer " + tok,
      },
    };
    let dynamicQuery = config.url;
    if (search) {
      dynamicQuery += `&${searchBy}=${search}`;
    }
    if (typeFilter) {
      dynamicQuery += `&leaderType=${typeFilter}`;
    }
    if (orderField) {
      dynamicQuery += `&orderField=${orderField}&orderDirection=${orderDirection}`;
    }
    // if (user?.role == "god_agent") {
    //   dynamicQuery += `&myTree=${myTree}`;
    // }
    config.url = dynamicQuery;

    await axios(config)
      .then(function (res) {
        // console.log("trx data: ", res?.data?.data?.transactions);
        setTransactions(res?.data?.data?.transactions);
        setPageCount(res?.data?.data?.pages);
        setTransactionApiCalled(true);

        // setLoader(false);
      })
      .catch(function (error) {
        // setLoader(false);
        setTransactionApiCalled(true);
      });
  };

  useEffect(() => {
    if (tok && tok !== "" && tok !== undefined) {
      // if (usdPrice && tomiPrice) {
         if (true) {
        if (user?.role == "mini_agent") {
          // setwelcome("Ambassador");
          // GetDashboardDataMyUsers1("all");
          GetMyData();
        } else if (user?.role == "agent") {
          // setwelcome("Leader");
          // GetDashboardDataMyUsers1("all");
          GetMyData();
        } else if (user?.role == "god_agent") {
          // setwelcome("God Leader");
          // GetDashboardDataMyUsers1("all");
          GetMyData();
        } else if (user?.role == "mega_agent") {
          // setwelcome("Mega Leader");
          // GetDashboardDataMyUsers1("all");
          GetMyData();
        } else if (user?.role == "super_agent") {
          // setwelcome("Super Leader");
          // GetDashboardDataMyUsers1("all");
          GetMyData();
        }
      }
    } else {
      history.push("/login");
    }
  }, [dataTime, usdPrice, tomiPrice]);

  // User gode mega leader super data upper stats
  const GetDashboardDataMyUsers = (times) => {
    setalllset();
    setuserselectdate(true);
    setState(times);
    // let date = null;
    // let date1 = null;
    // if (times) {
    //   let a = new Date(times[0]?.startDate);
    //   let b = new Date(times[0]?.endDate);
    //   date = moment(a).format("Y-MM-DDT00:00:00");
    //   date1 = moment(b).format("Y-MM-DDT23:59:59");
    // }
    const currentDate = moment();
    const startDate = moment(times[0]?.startDate, "Y-MM-DDT00:00:00");
    const endDate = moment(times[0]?.endDate, "Y-MM-DDT23:59:59");

    if (
      startDate &&
      endDate &&
      startDate.isBefore(currentDate) &&
      endDate.isBefore(currentDate)
    ) {
      var config = {
        method: "get",
        url: `${Api_Url}/users/my/stats?privateSale=${project}&startDate=${startDate.toISOString()}&&endDate=${endDate.toISOString()}`,
        headers: {
          authorization: `Bearer ` + tok,
        },
      };
      axios(config)
        .then(function (response) {
           console.log("sdfsfsdfsdfsdfdsfsdfdf", response);
          let value = response?.data?.data;
         
          setTokenNftStats(value);

          setTotPurchases(value?.totalPurchases);
          setDOPPurchased(value?.totalDopPurchased);

          setPurchasedAndEarnings(value?.purchasedAndEarnings);

          let purchasesOld =
            value?.oldPurchasesAndDopPurchased[0]?.TotalPurchases;
          let purchasesNew = value?.totalPurchases;

          let purchaseChange =
            ((purchasesNew - purchasesOld) / purchasesOld) * 100;
          setPC(purchaseChange);

          let oldPurchasedEth =
            value?.oldPurchasedAndEarnings[0]?._id?.tokenSelected == "ETH"
              ? value?.oldPurchasedAndEarnings[0]?.totalPurchase
              : value?.oldPurchasedAndEarnings[1]?._id?.tokenSelected == "ETH"
              ? value?.oldPurchasedAndEarnings[1]?.totalPurchase
              : value?.oldPurchasedAndEarnings[2]?._id?.tokenSelected == "ETH"
              ? value?.oldPurchasedAndEarnings[2]?.totalPurchase
              : 0;
          let oldPurchasedUsdt =
            value?.oldPurchasedAndEarnings[0]?._id?.tokenSelected == "USDT"
              ? value?.oldPurchasedAndEarnings[0]?.totalPurchase
              : value?.oldPurchasedAndEarnings[1]?._id?.tokenSelected == "USDT"
              ? value?.oldPurchasedAndEarnings[1]?.totalPurchase
              : value?.oldPurchasedAndEarnings[2]?._id?.tokenSelected == "USDT"
              ? value?.oldPurchasedAndEarnings[2]?.totalPurchase
              : 0;
          let oldPurchasedTomi =
            value?.oldPurchasedAndEarnings[0]?._id?.tokenSelected == "TOMI"
              ? value?.oldPurchasedAndEarnings[0]?.totalPurchase
              : value?.oldPurchasedAndEarnings[1]?._id?.tokenSelected == "TOMI"
              ? value?.oldPurchasedAndEarnings[1]?.totalPurchase
              : value?.oldPurchasedAndEarnings[2]?._id?.tokenSelected == "TOMI"
              ? value?.oldPurchasedAndEarnings[2]?.totalPurchase
              : 0;

          let newPurchasedEth =
            value?.purchasedAndEarnings[0]?._id?.tokenSelected == "ETH"
              ? value?.purchasedAndEarnings[0]?.totalPurchase
              : value?.purchasedAndEarnings[1]?._id?.tokenSelected == "ETH"
              ? value?.purchasedAndEarnings[1]?.totalPurchase
              : value?.purchasedAndEarnings[2]?._id?.tokenSelected == "EETH"
              ? value?.purchasedAndEarnings[2]?.totalPurchase
              : 0;
          let newPurchasedUsdt =
            value?.purchasedAndEarnings[0]?._id?.tokenSelected == "USDT"
              ? value?.purchasedAndEarnings[0]?.totalPurchase
              : value?.purchasedAndEarnings[1]?._id?.tokenSelected == "USDT"
              ? value?.purchasedAndEarnings[1]?.totalPurchase
              : value?.purchasedAndEarnings[2]?._id?.tokenSelected == "USDT"
              ? value?.purchasedAndEarnings[2]?.totalPurchase
              : 0;
          let newPurchasedTomi =
            value?.purchasedAndEarnings[0]?._id?.tokenSelected == "TOMI"
              ? value?.purchasedAndEarnings[0]?.totalPurchase
              : value?.purchasedAndEarnings[1]?._id?.tokenSelected == "TOMI"
              ? value?.purchasedAndEarnings[1]?.totalPurchase
              : value?.purchasedAndEarnings[2]?._id?.tokenSelected == "TOMI"
              ? value?.purchasedAndEarnings[2]?.totalPurchase
              : 0;

          let newPurchasedAmount =
            newPurchasedEth * usdPrice +
            newPurchasedUsdt +
            newPurchasedTomi * tomiPrice;
          let oldPurchasedAmount =
            oldPurchasedEth * usdPrice +
            oldPurchasedUsdt +
            oldPurchasedTomi * tomiPrice;

          let purchasedAmountChange = 0;

          if (newPurchasedAmount === 0 && oldPurchasedAmount === 0) {
            purchasedAmountChange = 0;
          } else if (newPurchasedAmount === 0 || oldPurchasedAmount === 0) {
            if (newPurchasedAmount === 0) {
              purchasedAmountChange =
                ((0 - oldPurchasedAmount) / oldPurchasedAmount) * 100;
            }
            if (oldPurchasedAmount === 0) {
              purchasedAmountChange = ((newPurchasedAmount + 1 - 1) / 1) * 100;
            }
          } else {
            purchasedAmountChange =
              ((newPurchasedAmount - oldPurchasedAmount) / oldPurchasedAmount) *
              100;
          }

          setPMC(purchasedAmountChange);

          let newLeadersCount =
            value?.agents +
            value?.godAgents +
            value?.megaAgents +
            value?.superAgents +
            value?.miniAgents;
          let oldLeadersCount =
            value?.oldleaders +
            value?.oldgodLeaders +
            value?.oldmegaLeaders +
            value?.oldsuperLeaders +
            value?.oldminiLeaders;
          let leadersChange = 0;
          if (newLeadersCount === 0 && oldLeadersCount === 0) {
            leadersChange = 0;
          } else if (newLeadersCount === 0 || oldLeadersCount === 0) {
            if (newLeadersCount === 0) {
              leadersChange = ((0 - oldLeadersCount) / oldLeadersCount) * 100;
            }
            if (oldLeadersCount === 0) {
              leadersChange = ((newLeadersCount + 1 - 1) / 1) * 100;
            }
          } else {
            leadersChange =
              ((newLeadersCount - oldLeadersCount) / oldLeadersCount) * 100;
          }

          setLC(leadersChange);
          let dopChange =
            ((value?.totalDopPurchased -
              value?.oldPurchasesAndDopPurchased[0]?.totalDopPurchased) /
              value?.oldPurchasesAndDopPurchased[0]?.totalDopPurchased) *
            100;

          setDPC(dopChange);

          let oldEarningsEth =
            value?.oldPurchasedAndEarnings[0]?._id?.tokenSelected == "ETH"
              ? value?.oldPurchasedAndEarnings[0]?.totalLeaderEarnings
              : value?.oldPurchasedAndEarnings[1]?._id?.tokenSelected == "ETH"
              ? value?.oldPurchasedAndEarnings[1]?.totalLeaderEarnings
              : value?.oldPurchasedAndEarnings[2]?._id?.tokenSelected == "ETH"
              ? value?.oldPurchasedAndEarnings[2]?.totalLeaderEarnings
              : 0;
          let oldEarningsUsdt =
            value?.oldPurchasedAndEarnings[0]?._id?.tokenSelected == "USDT"
              ? value?.oldPurchasedAndEarnings[0]?.totalLeaderEarnings
              : value?.oldPurchasedAndEarnings[1]?._id?.tokenSelected == "USDT"
              ? value?.oldPurchasedAndEarnings[1]?.totalLeaderEarnings
              : value?.oldPurchasedAndEarnings[2]?._id?.tokenSelected == "USDT"
              ? value?.oldPurchasedAndEarnings[2]?.totalLeaderEarnings
              : 0;
          let oldEarningsTomi =
            value?.oldPurchasedAndEarnings[0]?._id?.tokenSelected == "TOMI"
              ? value?.oldPurchasedAndEarnings[0]?.totalLeaderEarnings
              : value?.oldPurchasedAndEarnings[1]?._id?.tokenSelected == "TOMI"
              ? value?.oldPurchasedAndEarnings[1]?.totalLeaderEarnings
              : value?.oldPurchasedAndEarnings[2]?._id?.tokenSelected == "TOMI"
              ? value?.oldPurchasedAndEarnings[2]?.totalLeaderEarnings
              : 0;

          let newEarningsEth =
            value?.purchasedAndEarnings[0]?._id?.tokenSelected == "ETH"
              ? value?.purchasedAndEarnings[0]?.totalLeaderEarnings
              : value?.purchasedAndEarnings[1]?._id?.tokenSelected == "ETH"
              ? value?.purchasedAndEarnings[1]?.totalLeaderEarnings
              : value?.purchasedAndEarnings[2]?._id?.tokenSelected == "EETH"
              ? value?.purchasedAndEarnings[2]?.totalLeaderEarnings
              : 0;
          let newEarningsUsdt =
            value?.purchasedAndEarnings[0]?._id?.tokenSelected == "USDT"
              ? value?.purchasedAndEarnings[0]?.totalLeaderEarnings
              : value?.purchasedAndEarnings[1]?._id?.tokenSelected == "USDT"
              ? value?.purchasedAndEarnings[1]?.totalLeaderEarnings
              : value?.purchasedAndEarnings[2]?._id?.tokenSelected == "USDT"
              ? value?.purchasedAndEarnings[2]?.totalLeaderEarnings
              : 0;
          let newEarningsTomi =
            value?.purchasedAndEarnings[0]?._id?.tokenSelected == "TOMI"
              ? value?.purchasedAndEarnings[0]?.totalLeaderEarnings
              : value?.purchasedAndEarnings[1]?._id?.tokenSelected == "TOMI"
              ? value?.purchasedAndEarnings[1]?.totalLeaderEarnings
              : value?.purchasedAndEarnings[2]?._id?.tokenSelected == "TOMI"
              ? value?.purchasedAndEarnings[2]?.totalLeaderEarnings
              : 0;

          let earningsChange =
            ((newEarningsEth * usdPrice +
              newEarningsUsdt +
              newEarningsTomi * tomiPrice -
              (oldEarningsEth * usdPrice +
                oldEarningsUsdt +
                oldEarningsTomi * tomiPrice)) /
              (oldEarningsEth * usdPrice +
                oldEarningsUsdt +
                oldEarningsTomi * tomiPrice)) *
            100;

          let totalLeaderEarningsOldPrice =
            oldEarningsEth * usdPrice +
            oldEarningsUsdt +
            oldEarningsTomi * tomiPrice;
          let totalLeaderEarningsNewPrice =
            newEarningsEth * usdPrice +
            newEarningsUsdt +
            newEarningsTomi * tomiPrice;

          let totalLeadersEarningChange = 0;

          if (
            totalLeaderEarningsNewPrice === 0 &&
            totalLeaderEarningsOldPrice === 0
          ) {
            totalLeadersEarningChange = 0;
          } else if (
            totalLeaderEarningsNewPrice === 0 ||
            totalLeaderEarningsOldPrice === 0
          ) {
            if (totalLeaderEarningsNewPrice === 0) {
              totalLeadersEarningChange =
                ((0 - totalLeaderEarningsOldPrice) /
                  totalLeaderEarningsOldPrice) *
                100;
            }
            if (totalLeaderEarningsOldPrice === 0) {
              totalLeadersEarningChange =
                ((totalLeaderEarningsNewPrice + 1 - 1) / 1) * 100;
            }
          } else {
            totalLeadersEarningChange =
              ((totalLeaderEarningsNewPrice - totalLeaderEarningsOldPrice) /
                totalLeaderEarningsOldPrice) *
              100;
          }

          setLEC(totalLeadersEarningChange);
          setgg(value?.leaders);
          setggmini(value?.miniLeaders);
          setactiveleader(value?.activeLeaders);

          setmm(value?.megas);
          setss(value?.supers);
          // setTimeout(() => {
          //   setShowCalendar(false)
          // }, 3000);
        })
        .catch(function (error) {
          console.log(error);
        });
    } else {
      toast.error("Date must be today or earlier.");
    }
  };

  const GetDashboardDataMyUsers1 = (alll) => {
    setuserselectdate(true);
    let date = null;
    let date1 = null;
    if (alll == "1") {
      var date12 = new Date();
      var dateOffset = 24 * 60 * 60 * 1000 * 0; //1 month
      var myDate = new Date();
      myDate.setTime(myDate.getTime() - dateOffset);
      date = moment(myDate).utc().format("Y-MM-DDT00:00:00");
      date1 = moment(date12).utc().format("Y-MM-DDT23:59:59");

      ///////////////////////////////
      // var date12 = new Date();

      // var dateOffset = 24 * 60 * 60 * 1000; // 24 hours (1 day) in milliseconds
      // var myDate = new Date(date12.getTime() - dateOffset); // Subtract 24 hours from the current time

      // date = myDate.toISOString(); // Start time (24 hours ago)
      // date1 = date12.toISOString(); // Current time as end time
    } else if (alll == "seven") {
      var date12 = new Date();
      var dateOffset = 24 * 60 * 60 * 1000 * 7; //1 month
      var myDate = new Date();
      myDate.setTime(myDate.getTime() - dateOffset);
      date = moment(myDate).utc().format("Y-MM-DDT00:00:00");
      date1 = moment(date12).utc().format("Y-MM-DDT23:59:59");
    } else if (alll == "year") {
      var date12 = new Date();
      var dateOffset = 24 * 60 * 60 * 1000 * 365; //1 month
      var myDate = new Date();
      myDate.setTime(myDate.getTime() - dateOffset);
      date = moment(myDate).utc().format("Y-MM-DDT00:00:00");
      date1 = moment(date12).utc().format("Y-MM-DDT23:59:59");
    } else if (alll == "month") {
      var date12 = new Date();
      var dateOffset = 24 * 60 * 60 * 1000 * 31; //1 month
      var myDate = new Date();
      myDate.setTime(myDate.getTime() - dateOffset);
      date = moment(myDate).utc().format("Y-MM-DDT00:00:00");
      date1 = moment(date12).utc().format("Y-MM-DDT23:59:59");
    }
    if (date && date1) {
      var config = {
        method: "get",
        url: `${Api_Url}/users/my/stats?privateSale=${project}&startDate=${date}&endDate=${date1}`,
        headers: {
          authorization: `Bearer ` + tok,
        },
      };
      axios(config)
        .then(function (response) {
          // console.log("responce",response)
          let value = response?.data?.data;
          // console.log("sdfsfsdfsdfsdfdsfsdfdf", value)
          setTokenNftStats(value);

          setTotPurchases(value?.totalPurchases);
          setDOPPurchased(value?.totalDopPurchased);
          setPurchasedAndEarnings(value?.purchasedAndEarnings);

          let purchasesOld =
            value?.oldPurchasesAndDopPurchased[0]?.TotalPurchases;
          let purchasesNew = value?.totalPurchases;

          let purchaseChange =
            ((purchasesNew - purchasesOld) / purchasesOld) * 100;
          setPC(purchaseChange);

          let oldPurchasedEth =
            value?.oldPurchasedAndEarnings[0]?._id?.tokenSelected == "ETH"
              ? value?.oldPurchasedAndEarnings[0]?.totalPurchase
              : value?.oldPurchasedAndEarnings[1]?._id?.tokenSelected == "ETH"
              ? value?.oldPurchasedAndEarnings[1]?.totalPurchase
              : value?.oldPurchasedAndEarnings[2]?._id?.tokenSelected == "ETH"
              ? value?.oldPurchasedAndEarnings[2]?.totalPurchase
              : 0;
          let oldPurchasedUsdt =
            value?.oldPurchasedAndEarnings[0]?._id?.tokenSelected == "USDT"
              ? value?.oldPurchasedAndEarnings[0]?.totalPurchase
              : value?.oldPurchasedAndEarnings[1]?._id?.tokenSelected == "USDT"
              ? value?.oldPurchasedAndEarnings[1]?.totalPurchase
              : value?.oldPurchasedAndEarnings[2]?._id?.tokenSelected == "USDT"
              ? value?.oldPurchasedAndEarnings[2]?.totalPurchase
              : 0;
          let oldPurchasedTomi =
            value?.oldPurchasedAndEarnings[0]?._id?.tokenSelected == "TOMI"
              ? value?.oldPurchasedAndEarnings[0]?.totalPurchase
              : value?.oldPurchasedAndEarnings[1]?._id?.tokenSelected == "TOMI"
              ? value?.oldPurchasedAndEarnings[1]?.totalPurchase
              : value?.oldPurchasedAndEarnings[2]?._id?.tokenSelected == "TOMI"
              ? value?.oldPurchasedAndEarnings[2]?.totalPurchase
              : 0;

          let newPurchasedEth =
            value?.purchasedAndEarnings[0]?._id?.tokenSelected == "ETH"
              ? value?.purchasedAndEarnings[0]?.totalPurchase
              : value?.purchasedAndEarnings[1]?._id?.tokenSelected == "ETH"
              ? value?.purchasedAndEarnings[1]?.totalPurchase
              : value?.purchasedAndEarnings[2]?._id?.tokenSelected == "EETH"
              ? value?.purchasedAndEarnings[2]?.totalPurchase
              : 0;
          let newPurchasedUsdt =
            value?.purchasedAndEarnings[0]?._id?.tokenSelected == "USDT"
              ? value?.purchasedAndEarnings[0]?.totalPurchase
              : value?.purchasedAndEarnings[1]?._id?.tokenSelected == "USDT"
              ? value?.purchasedAndEarnings[1]?.totalPurchase
              : value?.purchasedAndEarnings[2]?._id?.tokenSelected == "USDT"
              ? value?.purchasedAndEarnings[2]?.totalPurchase
              : 0;
          let newPurchasedTomi =
            value?.purchasedAndEarnings[0]?._id?.tokenSelected == "TOMI"
              ? value?.purchasedAndEarnings[0]?.totalPurchase
              : value?.purchasedAndEarnings[1]?._id?.tokenSelected == "TOMI"
              ? value?.purchasedAndEarnings[1]?.totalPurchase
              : value?.purchasedAndEarnings[2]?._id?.tokenSelected == "TOMI"
              ? value?.purchasedAndEarnings[2]?.totalPurchase
              : 0;

          let newPurchasedAmount =
            newPurchasedEth * usdPrice +
            newPurchasedUsdt +
            newPurchasedTomi * tomiPrice;
          let oldPurchasedAmount =
            oldPurchasedEth * usdPrice +
            oldPurchasedUsdt +
            oldPurchasedTomi * tomiPrice;

          let purchasedAmountChange = 0;

          if (newPurchasedAmount === 0 && oldPurchasedAmount === 0) {
            purchasedAmountChange = 0;
          } else if (newPurchasedAmount === 0 || oldPurchasedAmount === 0) {
            if (newPurchasedAmount === 0) {
              purchasedAmountChange =
                ((0 - oldPurchasedAmount) / oldPurchasedAmount) * 100;
            }
            if (oldPurchasedAmount === 0) {
              purchasedAmountChange = ((newPurchasedAmount + 1 - 1) / 1) * 100;
            }
          } else {
            purchasedAmountChange =
              ((newPurchasedAmount - oldPurchasedAmount) / oldPurchasedAmount) *
              100;
          }

          setPMC(purchasedAmountChange);
          let newLeadersCount =
            value?.agents +
            value?.godAgents +
            value?.megaAgents +
            value?.superAgents +
            value?.miniAgents;
          let oldLeadersCount =
            value?.oldleaders +
            value?.oldgodLeaders +
            value?.oldmegaLeaders +
            value?.oldsuperLeaders +
            value?.oldminiLeaders;
          let leadersChange = 0;
          if (newLeadersCount === 0 && oldLeadersCount === 0) {
            leadersChange = 0;
          } else if (newLeadersCount === 0 || oldLeadersCount === 0) {
            if (newLeadersCount === 0) {
              leadersChange = ((0 - oldLeadersCount) / oldLeadersCount) * 100;
            }
            if (oldLeadersCount === 0) {
              leadersChange = ((newLeadersCount + 1 - 1) / 1) * 100;
            }
          } else {
            leadersChange =
              ((newLeadersCount - oldLeadersCount) / oldLeadersCount) * 100;
          }

          setLC(leadersChange);
          let oldDOPChange =
            value?.oldPurchasesAndDopPurchased[0]?.totalDopPurchased;
          let dopChange =
            ((value?.totalDopPurchased - oldDOPChange) / oldDOPChange) * 100;

          setDPC(dopChange);

          let oldEarningsEth =
            value?.oldPurchasedAndEarnings[0]?._id?.tokenSelected == "ETH"
              ? value?.oldPurchasedAndEarnings[0]?.totalLeaderEarnings
              : value?.oldPurchasedAndEarnings[1]?._id?.tokenSelected == "ETH"
              ? value?.oldPurchasedAndEarnings[1]?.totalLeaderEarnings
              : value?.oldPurchasedAndEarnings[2]?._id?.tokenSelected == "ETH"
              ? value?.oldPurchasedAndEarnings[2]?.totalLeaderEarnings
              : 0;
          let oldEarningsUsdt =
            value?.oldPurchasedAndEarnings[0]?._id?.tokenSelected == "USDT"
              ? value?.oldPurchasedAndEarnings[0]?.totalLeaderEarnings
              : value?.oldPurchasedAndEarnings[1]?._id?.tokenSelected == "USDT"
              ? value?.oldPurchasedAndEarnings[1]?.totalLeaderEarnings
              : value?.oldPurchasedAndEarnings[2]?._id?.tokenSelected == "USDT"
              ? value?.oldPurchasedAndEarnings[2]?.totalLeaderEarnings
              : 0;
          let oldEarningsTomi =
            value?.oldPurchasedAndEarnings[0]?._id?.tokenSelected == "TOMI"
              ? value?.oldPurchasedAndEarnings[0]?.totalLeaderEarnings
              : value?.oldPurchasedAndEarnings[1]?._id?.tokenSelected == "TOMI"
              ? value?.oldPurchasedAndEarnings[1]?.totalLeaderEarnings
              : value?.oldPurchasedAndEarnings[2]?._id?.tokenSelected == "TOMI"
              ? value?.oldPurchasedAndEarnings[2]?.totalLeaderEarnings
              : 0;

          let newEarningsEth =
            value?.purchasedAndEarnings[0]?._id?.tokenSelected == "ETH"
              ? value?.purchasedAndEarnings[0]?.totalLeaderEarnings
              : value?.purchasedAndEarnings[1]?._id?.tokenSelected == "ETH"
              ? value?.purchasedAndEarnings[1]?.totalLeaderEarnings
              : value?.purchasedAndEarnings[2]?._id?.tokenSelected == "EETH"
              ? value?.purchasedAndEarnings[2]?.totalLeaderEarnings
              : 0;
          let newEarningsUsdt =
            value?.purchasedAndEarnings[0]?._id?.tokenSelected == "USDT"
              ? value?.purchasedAndEarnings[0]?.totalLeaderEarnings
              : value?.purchasedAndEarnings[1]?._id?.tokenSelected == "USDT"
              ? value?.purchasedAndEarnings[1]?.totalLeaderEarnings
              : value?.purchasedAndEarnings[2]?._id?.tokenSelected == "USDT"
              ? value?.purchasedAndEarnings[2]?.totalLeaderEarnings
              : 0;
          let newEarningsTomi =
            value?.purchasedAndEarnings[0]?._id?.tokenSelected == "TOMI"
              ? value?.purchasedAndEarnings[0]?.totalLeaderEarnings
              : value?.purchasedAndEarnings[1]?._id?.tokenSelected == "TOMI"
              ? value?.purchasedAndEarnings[1]?.totalLeaderEarnings
              : value?.purchasedAndEarnings[2]?._id?.tokenSelected == "TOMI"
              ? value?.purchasedAndEarnings[2]?.totalLeaderEarnings
              : 0;

          let totalLeaderEarningsOldPrice =
            oldEarningsEth * usdPrice +
            oldEarningsUsdt +
            oldEarningsTomi * tomiPrice;
          let totalLeaderEarningsNewPrice =
            newEarningsEth * usdPrice +
            newEarningsUsdt +
            newEarningsTomi * tomiPrice;

          let totalLeadersEarningChange = 0;

          if (
            totalLeaderEarningsNewPrice === 0 &&
            totalLeaderEarningsOldPrice === 0
          ) {
            totalLeadersEarningChange = 0;
          } else if (
            totalLeaderEarningsNewPrice === 0 ||
            totalLeaderEarningsOldPrice === 0
          ) {
            if (totalLeaderEarningsNewPrice === 0) {
              totalLeadersEarningChange =
                ((0 - totalLeaderEarningsOldPrice) /
                  totalLeaderEarningsOldPrice) *
                100;
            }
            if (totalLeaderEarningsOldPrice === 0) {
              totalLeadersEarningChange =
                ((totalLeaderEarningsNewPrice + 1 - 1) / 1) * 100;
            }
          } else {
            totalLeadersEarningChange =
              ((totalLeaderEarningsNewPrice - totalLeaderEarningsOldPrice) /
                totalLeaderEarningsOldPrice) *
              100;
          }

          setLEC(totalLeadersEarningChange);
          setgg(value?.leaders);
          setggmini(value?.miniLeaders);
          setactiveleader(value?.activeLeaders);

          setmm(value?.megas);
          setss(value?.supers);
          // if (response?.data?.data?.stats?.length > 0) {
          //   // setadminobj(response?.data?.data?.stats[0]);
          // }
          // let value = response?.data?.data;
          // setPC(value?.purchasesChange)
          // setPMC(value?.purchasesAmountChange)
          // setNRC(value?.netRevenueChange)
          // setLC(value?.leadersChange)
          // setDPC(value?.dopPurchasedChange)
          // setLEC(value?.leaderEarningsChange)

          // seta(value?.agents);
          // setg(value?.godAgents);
          // setm(value?.megaAgents);
          // sets(value?.superAgents);
          // settotalleader(
          //   value?.agents +
          //   value?.godAgents +
          //   value?.megaAgents +
          //   value?.superAgents
          // );
        })
        .catch(function (error) {
          if (error?.response?.status == 401) {
            localStorage.removeItem("accessToken");
            history.push("/login");
          }
          console.log(error);
        });
    }
  };

  const GetMyData = async () => {
    const tok = localStorage?.getItem("accessToken");
    // if (account) {
    var config = {
      method: "get",
      url: `${Api_Url}/users/my/stats?privateSale=${project}`,
      headers: {
        authorization: `Bearer ` + tok,
      },
    };
    axios(config)
      .then(function (response) {
        setuserselectdate(false);
        let value = response?.data?.data;
        setTokenNftStats(value);

        // console.log("sdfsfsdfsdfsdfdsfsdfdf", value);

        setTotPurchases(value?.totalPurchases);
        setDOPPurchased(value?.totalDopPurchased);
        setPurchasedAndEarnings(value?.purchasedAndEarnings);

        setPC(0);

        setPMC(0);

        setLC(0);

        setDPC(0);

        setLEC(0);
        setgg(value?.leaders);
        setggmini(value?.miniLeaders);
        setactiveleader(value?.activeLeaders);

        setmm(value?.megas);
        setss(value?.supers);
      })
      .catch(function (error) {
        // console.log("status: ", error?.response);
        if (error?.response?.status == 401) {
          // history.push("/login");
        }

        console.log(error);
      });
    // }
  };

  const [showTooltip, setShowTooltip] = useState(false);

  const handleMouseEnter = () => {
    setShowTooltip(true);
  };

  const handleMouseLeave = () => {
    setShowTooltip(false);
  };

  const handleTooltipMouseEnter = () => {
    setShowTooltip(true);
  };

  const handleTooltipMouseLeave = () => {
    setShowTooltip(false);
  };

  function convertToTitleCase(input) {
    if (input) {
      let words = input
        .split("_")
        .map(
          (word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()
        );

      if (words[0] === "mini" || words[0] === "Mini") {
        return "Ambassador";
      }
      if (
        words[words.length - 1].toLowerCase() === "agent" &&
        (words[0] != "mini" || words[0] != "Mini")
      ) {
        words[words.length - 1] = "Leader";
      }
      if (words[0] === "super" || words[0] === "Super") {
        return "Super Leader";
      } else if (words[0] !== "agent") {
        return words.join(" ");
      } else {
        return "Leader";
      }
    } else {
      return "";
    }
  }

  const tokens = [
    "ETH",
    "USDT",
       "USDC",
    // "DOP",
    // "WBTC",
    // "GEMS",
    // "TOMI",
 
    // "PEPE",
    // "UNI",
    // "LINK",
  ];
  const calculateTotalPurchasesOverall = () => {
    if (!purchasesAndEarnings?.length) return 0;

    const tokens = [
      { name: "ETH", price: usdPrice },
      { name: "USDT", price: 1 },
{ name: "USDC", price: 1 },


            { name: "DOP", price: dopPrice },
      { name: "WBTC", price: btcPrice },
      { name: "GEMS", price: gemsPrice },
      { name: "PEPE", price: pepePrice },
      { name: "UNI", price: uniPrice },
      { name: "LINK", price: linkPrice },
      { name: "TOMI", price: tomiPrice },
    ];

    return purchasesAndEarnings
      .reduce((total, purchase) => {
        const token = tokens.find(
          (t) => t.name === purchase?._id?.tokenSelected
        );
        return token ? total + token.price * purchase.totalPurchase : total;
      }, 0)
      .toFixed(4);
  };

  const calculateMyEarningsOverall = () => {
    if (!purchasesAndEarnings?.length) return 0;

    const tokens = [
      { name: "ETH", price: usdPrice },
      { name: "USDT", price: 1 },
      { name: "DOP", price: dopPrice },
      { name: "WBTC", price: btcPrice },

      { name: "USDC", price: 1 },
      { name: "GEMS", price: gemsPrice },
      { name: "PEPE", price: pepePrice },
      { name: "UNI", price: uniPrice },
      { name: "LINK", price: linkPrice },
      { name: "TOMI", price: tomiPrice },
    ];

    return purchasesAndEarnings
      .reduce((total, purchase) => {
        const token = tokens.find(
          (t) => t.name === purchase?._id?.tokenSelected
        );
        return token
          ? total + token.price * purchase.totalLeaderEarnings
          : total;
      }, 0)
      .toFixed(4);
  };
  return (
    <>
      <Header />
      <section className="maindashboard">
        <div className="theme-container">
          {/* <div className="twice-elem">
            <div className="dashboarddetailmain set-custom-common-width">
              <div className="dashboarddetailleft">
                {project == "INCENTIV" ? (
                  <>
                    <div className="detailcard">
                      <div className="detailimg">
                        <img
                          src="/assets/incetive-card-logo.png"
                          alt="detailinnerimg"
                          className="detailinnerimg"
                        />
                      </div>
                      <div className="detailcardtexts">
                        <h6 className="detailcardhead">INC</h6>
                        <p className="detailcardpara">INC</p>
                      </div>
                    </div>
                  </>
                ) : project == "GEMS" ? (
                  <>
                    <div className="detailcard">
                      <div className="detailimg">
                        <img
                          src="/assets/gemslogo.png"
                          alt="detailinnerimg"
                          className="detailinnerimg"
                        />
                      </div>
                      <div className="detailcardtexts">
                        <h6 className="detailcardhead">GEMS</h6>
                        <p className="detailcardpara">GEMS</p>
                      </div>
                    </div>
                  </>
                ) : (
                  <>
                    <div className="detailcard">
                      <div className="detailimg">
                        <img
                          src="\assets\dashboardassets\ongoingcardone.svg"
                          alt="detailinnerimg"
                          className="detailinnerimg"
                        />
                      </div>
                      <div className="detailcardtexts">
                        <h6 className="detailcardhead">DOP</h6>
                        <p className="detailcardpara">DOP</p>
                      </div>
                    </div>
                  </>
                )}

                <div className="detailmainheading">
                  <div className="detailmain">
                    <p className="detailmainpara">Round No.</p>
                    <h6 className="detailmainhead">{round.toString()}</h6>
                  </div>
                  <div className="detailmain">
                    <p className="detailmainpara">Owner Name</p>
                    {project == "INCENTIV" ? (
                      <h6 className="detailmainhead">INCENTIV Labs</h6>
                    ) : project == "DOP" ? (
                      <h6 className="detailmainhead">DOP Labs</h6>
                    ) : (
                      <h6 className="detailmainhead">Xen Labs</h6>
                    )}
                  </div>
                  <div className="detailmain">
                    <p className="detailmainpara">Created Date</p>
                    {project == "INCENTIV" ? (
                      <h6 className="detailmainhead">09/06/2024</h6>
                    ) : project == "DOP" ? (
                      <h6 className="detailmainhead">01/09/2023</h6>
                    ) : (
                      <h6 className="detailmainhead">23/04/2024</h6>
                    )}
                  </div>
                </div>
              </div>
              <div className="detailbtns">
              <button className="whitedetailbtn">
                Details{" "}
                <img
                  src="\assets\dashboardassets\External_Link.svg"
                  alt="detailimg"
                  className="detailimg"
                />
              </button>
              <button className="leavebtn" onClick={handleShow}>
                Leave Project
              </button>
            </div>
            </div>
            <div className="staking-box set-custom-common-width">
              <img
                src="\assets\stake-bg.png"
                alt="img"
                className="img-fluid stake-bg"
              />
              <div className="text">
                <p>Current Plan</p>
                {stakedAmount >= 18000 ? <h6>Premium</h6> : <h6>Basic</h6>}

                <h6 style={{ color: "#EAB44C" }}><svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                  <path d="M9.375 15.2084H7.5C6.58333 15.2084 5.83333 15.9584 5.83333 16.875V17.0834H5C4.65833 17.0834 4.375 17.3667 4.375 17.7084C4.375 18.05 4.65833 18.3334 5 18.3334H15C15.3417 18.3334 15.625 18.05 15.625 17.7084C15.625 17.3667 15.3417 17.0834 15 17.0834H14.1667V16.875C14.1667 15.9584 13.4167 15.2084 12.5 15.2084H10.625V13.3C10.4167 13.325 10.2083 13.3334 10 13.3334C9.79167 13.3334 9.58333 13.325 9.375 13.3V15.2084Z" fill="#EAB44C" />
                  <path d="M15.3999 9.70008C15.9499 9.49175 16.4332 9.15008 16.8166 8.76675C17.5916 7.90842 18.0999 6.88342 18.0999 5.68342C18.0999 4.48342 17.1582 3.54175 15.9582 3.54175H15.4916C14.9499 2.43341 13.8166 1.66675 12.4999 1.66675H7.4999C6.18324 1.66675 5.0499 2.43341 4.50824 3.54175H4.04157C2.84157 3.54175 1.8999 4.48342 1.8999 5.68342C1.8999 6.88342 2.40824 7.90842 3.18324 8.76675C3.56657 9.15008 4.0499 9.49175 4.5999 9.70008C5.46657 11.8334 7.5499 13.3334 9.9999 13.3334C12.4499 13.3334 14.5332 11.8334 15.3999 9.70008ZM12.3666 7.04175L11.8499 7.67508C11.7666 7.76675 11.7082 7.95008 11.7166 8.07508L11.7666 8.89175C11.7999 9.39175 11.4416 9.65008 10.9749 9.46675L10.2166 9.16675C10.0999 9.12508 9.8999 9.12508 9.78324 9.16675L9.0249 9.46675C8.55824 9.65008 8.1999 9.39175 8.23324 8.89175L8.28324 8.07508C8.29157 7.95008 8.23324 7.76675 8.1499 7.67508L7.63324 7.04175C7.30824 6.65842 7.4499 6.23342 7.93324 6.10842L8.7249 5.90842C8.8499 5.87508 8.9999 5.75842 9.06657 5.65008L9.50824 4.96675C9.78324 4.54175 10.2166 4.54175 10.4916 4.96675L10.9332 5.65008C10.9999 5.75842 11.1499 5.87508 11.2749 5.90842L12.0666 6.10842C12.5499 6.23342 12.6916 6.65842 12.3666 7.04175Z" fill="#EAB44C" />
                </svg> Premium</h6>
              </div>
              <div className="text">
                <p>GEMS Staked</p>
                <h6>
                  {stakedAmount?.toLocaleString()}
                  <Link to="/premium" className="btn-stake">
                    Stake
                  </Link>
                </h6>
              </div>
              <div className="text">
                <div className="tooltip-div">
                  <OverlayTrigger
                    placement="bottom"
                    overlay={
                      <Tooltip
                        id="smooth-tooltip"
                        onMouseEnter={handleTooltipMouseEnter}
                        onMouseLeave={handleTooltipMouseLeave}
                      >
                        <h4>Premium plan requirements for</h4>
                        <h5>{convertToTitleCase(user?.role)}</h5>
                        <div className="twice-fields">
                          <div className="inside-text">
                            <p>GEMS Staking Required</p>
                            <h6>18,000 GEMS</h6>
                          </div>
                        </div>
                      </Tooltip>
                    }
                    show={showTooltip}
                  >
                    <div
                      onMouseEnter={handleMouseEnter}
                      onMouseLeave={handleMouseLeave}
                      style={{ cursor: "pointer" }}
                    >
                      <img
                        src="\assets\tooltip.svg"
                        alt="img"
                        className="img-fluid"
                      />
                    </div>
                  </OverlayTrigger>
                </div>
              </div>
            </div>
          </div> */}
          <div className="upperdashboardmain">
            <h4 className="dashboardmainhead">XEN Dashboard</h4>

            <div className="custom-tab-bar">
              <a
                className={alllset == "1" ? "active" : "noactive"}
                onClick={() => {
                  console.log("data 1 called");
                  setalllset("1");
                  GetDashboardDataMyUsers1("1");
                  // setDataTime("1");
                }}
              >
                1D
              </a>
              <a
                className={alllset == "seven" ? "active" : "noactive"}
                onClick={() => {
                  console.log("data 7 called");

                  setalllset("seven");
                  GetDashboardDataMyUsers1("seven");
                  // setDataTime("seven");
                }}
              >
                7D
              </a>
              <a
                className={alllset == "month" ? "active" : "noactive"}
                onClick={() => {
                  console.log("data month called");

                  setalllset("month");
                  GetDashboardDataMyUsers1("month");
                  // setDataTime("month");
                }}
              >
                1M
              </a>
              <a
                className={alllset == "year" ? "active" : "noactive"}
                onClick={() => {
                  setalllset("year");
                  GetDashboardDataMyUsers1("year");
                  // setDataTime("year");
                }}
              >
                1Y
              </a>
              <a
                className={alllset == "all" ? "active" : "noactive"}
                onClick={() => {
                  setalllset("all");
                  GetMyData();
                  // setDataTime("");
                }}
              >
                All
              </a>
              <a onClick={() => setShowCalendar(!showcalendar)}>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="25"
                  height="24"
                  viewBox="0 0 25 24"
                  fill="none"
                >
                  <path
                    d="M17.0833 3.56V2C17.0833 1.59 16.7433 1.25 16.3333 1.25C15.9233 1.25 15.5833 1.59 15.5833 2V3.5H9.08327V2C9.08327 1.59 8.74327 1.25 8.33327 1.25C7.92327 1.25 7.58327 1.59 7.58327 2V3.56C4.88327 3.81 3.57327 5.42 3.37327 7.81C3.35327 8.1 3.59327 8.34 3.87327 8.34H20.7933C21.0833 8.34 21.3233 8.09 21.2933 7.81C21.0933 5.42 19.7833 3.81 17.0833 3.56Z"
                    fill="#8C8C8C"
                  />
                  <path
                    d="M20.3333 9.83984H4.33328C3.78328 9.83984 3.33328 10.2898 3.33328 10.8398V16.9998C3.33328 19.9998 4.83328 21.9998 8.33328 21.9998H16.3333C19.8333 21.9998 21.3333 19.9998 21.3333 16.9998V10.8398C21.3333 10.2898 20.8833 9.83984 20.3333 9.83984ZM9.54328 18.2098C9.49328 18.2498 9.44328 18.2998 9.39328 18.3298C9.33328 18.3698 9.27328 18.3998 9.21328 18.4198C9.15328 18.4498 9.09328 18.4698 9.03328 18.4798C8.96328 18.4898 8.90328 18.4998 8.83328 18.4998C8.70328 18.4998 8.57328 18.4698 8.45328 18.4198C8.32328 18.3698 8.22328 18.2998 8.12328 18.2098C7.94328 18.0198 7.83328 17.7598 7.83328 17.4998C7.83328 17.2398 7.94328 16.9798 8.12328 16.7898C8.22328 16.6998 8.32328 16.6298 8.45328 16.5798C8.63328 16.4998 8.83328 16.4798 9.03328 16.5198C9.09328 16.5298 9.15328 16.5498 9.21328 16.5798C9.27328 16.5998 9.33328 16.6298 9.39328 16.6698C9.44328 16.7098 9.49328 16.7498 9.54328 16.7898C9.72328 16.9798 9.83328 17.2398 9.83328 17.4998C9.83328 17.7598 9.72328 18.0198 9.54328 18.2098ZM9.54328 14.7098C9.35328 14.8898 9.09328 14.9998 8.83328 14.9998C8.57328 14.9998 8.31328 14.8898 8.12328 14.7098C7.94328 14.5198 7.83328 14.2598 7.83328 13.9998C7.83328 13.7398 7.94328 13.4798 8.12328 13.2898C8.40328 13.0098 8.84328 12.9198 9.21328 13.0798C9.34328 13.1298 9.45328 13.1998 9.54328 13.2898C9.72328 13.4798 9.83328 13.7398 9.83328 13.9998C9.83328 14.2598 9.72328 14.5198 9.54328 14.7098ZM13.0433 18.2098C12.8533 18.3898 12.5933 18.4998 12.3333 18.4998C12.0733 18.4998 11.8133 18.3898 11.6233 18.2098C11.4433 18.0198 11.3333 17.7598 11.3333 17.4998C11.3333 17.2398 11.4433 16.9798 11.6233 16.7898C11.9933 16.4198 12.6733 16.4198 13.0433 16.7898C13.2233 16.9798 13.3333 17.2398 13.3333 17.4998C13.3333 17.7598 13.2233 18.0198 13.0433 18.2098ZM13.0433 14.7098C12.9933 14.7498 12.9433 14.7898 12.8933 14.8298C12.8333 14.8698 12.7733 14.8998 12.7133 14.9198C12.6533 14.9498 12.5933 14.9698 12.5333 14.9798C12.4633 14.9898 12.4033 14.9998 12.3333 14.9998C12.0733 14.9998 11.8133 14.8898 11.6233 14.7098C11.4433 14.5198 11.3333 14.2598 11.3333 13.9998C11.3333 13.7398 11.4433 13.4798 11.6233 13.2898C11.7133 13.1998 11.8233 13.1298 11.9533 13.0798C12.3233 12.9198 12.7633 13.0098 13.0433 13.2898C13.2233 13.4798 13.3333 13.7398 13.3333 13.9998C13.3333 14.2598 13.2233 14.5198 13.0433 14.7098ZM16.5433 18.2098C16.3533 18.3898 16.0933 18.4998 15.8333 18.4998C15.5733 18.4998 15.3133 18.3898 15.1233 18.2098C14.9433 18.0198 14.8333 17.7598 14.8333 17.4998C14.8333 17.2398 14.9433 16.9798 15.1233 16.7898C15.4933 16.4198 16.1733 16.4198 16.5433 16.7898C16.7233 16.9798 16.8333 17.2398 16.8333 17.4998C16.8333 17.7598 16.7233 18.0198 16.5433 18.2098ZM16.5433 14.7098C16.4933 14.7498 16.4433 14.7898 16.3933 14.8298C16.3333 14.8698 16.2733 14.8998 16.2133 14.9198C16.1533 14.9498 16.0933 14.9698 16.0333 14.9798C15.9633 14.9898 15.8933 14.9998 15.8333 14.9998C15.5733 14.9998 15.3133 14.8898 15.1233 14.7098C14.9433 14.5198 14.8333 14.2598 14.8333 13.9998C14.8333 13.7398 14.9433 13.4798 15.1233 13.2898C15.2233 13.1998 15.3233 13.1298 15.4533 13.0798C15.6333 12.9998 15.8333 12.9798 16.0333 13.0198C16.0933 13.0298 16.1533 13.0498 16.2133 13.0798C16.2733 13.0998 16.3333 13.1298 16.3933 13.1698C16.4433 13.2098 16.4933 13.2498 16.5433 13.2898C16.7233 13.4798 16.8333 13.7398 16.8333 13.9998C16.8333 14.2598 16.7233 14.5198 16.5433 14.7098Z"
                    fill="#8C8C8C"
                  />
                </svg>
              </a>
              {/* {showcalendar && ( */}
              {showcalendar && (
                <div className="cal set-custom-calendar-div">
                  <DateRange
                    editableDateInputs={true}
                    onChange={(item) => {
                      GetDashboardDataMyUsers([item.selection]);
                    }}
                    moveRangeOnFirstSelection={false}
                    ranges={state}
                  />
                </div>
              )}
            </div>
          </div>

          <div className="dashboardboxesmain">
            <div className="innerdashboardbox">
              <div className="innerdashboardboxupper">
                <img
                  src="\assets\dashboardassets\detailcardone.svg"
                  alt="dashboardboximg"
                  className="dashboardboximg"
                />
                <div className="dashboardboxtexts">
                  <p className="dashboardparatopbox">My Code</p>
                  <h6 className="codepara">
                    {/* {tokenNftStats?.accessCode} */}
                    {copy ? (
                      <span className="adadasdasdasdasdasdsad">
                        {tokenNftStats?.accessCode}
                        <svg
                          style={{ cursor: "pointer" }}
                          xmlns="http://www.w3.org/2000/svg"
                          width="17"
                          height="17"
                          viewBox="0 0 17 17"
                          fill="none"
                        >
                          <path
                            d="M6.93619 6.47851L6.95629 4.61208C6.96433 3.86539 6.96835 3.49176 7.11674 3.20813C7.24726 2.95864 7.45327 2.75702 7.70552 2.63189C7.99228 2.48965 8.36591 2.49367 9.1126 2.50171L12.8457 2.54191C13.5924 2.54995 13.9656 2.55397 14.2492 2.70236C14.4987 2.83288 14.7007 3.0389 14.8258 3.29114C14.968 3.5779 14.964 3.95125 14.956 4.69795L14.9158 8.43108C14.9077 9.17777 14.9037 9.55112 14.7553 9.83475C14.6248 10.0842 14.4182 10.2863 14.166 10.4114C13.8795 10.5535 13.5067 10.5495 12.7615 10.5415L10.8929 10.5213M6.93619 6.47851L5.06976 6.45841C4.32307 6.45037 3.94944 6.44635 3.66268 6.58859C3.41043 6.71371 3.20443 6.91533 3.0739 7.16482C2.92551 7.44846 2.92149 7.82208 2.91345 8.56878L2.87325 12.3019C2.86521 13.0486 2.86119 13.4217 3.00344 13.7085C3.12856 13.9607 3.33017 14.1671 3.57967 14.2976C3.86302 14.4459 4.23619 14.4499 4.98143 14.4579L8.71897 14.4982C9.46421 14.5062 9.83686 14.5102 10.1233 14.3681C10.3756 14.243 10.582 14.0408 10.7125 13.7913C10.8607 13.508 10.8647 13.1352 10.8728 12.39L10.8929 10.5213M6.93619 6.47851L8.80288 6.49861C9.54957 6.50665 9.92272 6.51067 10.2064 6.65906C10.4558 6.78958 10.6578 6.99559 10.7829 7.24784C10.9251 7.53432 10.921 7.9075 10.913 8.65275L10.8929 10.5213"
                            stroke="#77868B"
                            stroke-width="1.5"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          />
                        </svg>

                        {copy && (
                          <p style={{ fontSize: 14 }} className="copy-text">
                            Copied
                          </p>
                        )}
                      </span>
                    ) : (
                      <>
                        {tokenNftStats?.accessCode && (
                          <CopyToClipboard
                            text={tokenNftStats?.accessCode}
                            onCopy={textCopiedFun2}
                          >
                            <span className="adadasdasdasdasdasdsad">
                              {tokenNftStats?.accessCode}
                              <svg
                                style={{ cursor: "pointer" }}
                                xmlns="http://www.w3.org/2000/svg"
                                width="17"
                                height="17"
                                viewBox="0 0 17 17"
                                fill="none"
                              >
                                <path
                                  d="M6.93619 6.47851L6.95629 4.61208C6.96433 3.86539 6.96835 3.49176 7.11674 3.20813C7.24726 2.95864 7.45327 2.75702 7.70552 2.63189C7.99228 2.48965 8.36591 2.49367 9.1126 2.50171L12.8457 2.54191C13.5924 2.54995 13.9656 2.55397 14.2492 2.70236C14.4987 2.83288 14.7007 3.0389 14.8258 3.29114C14.968 3.5779 14.964 3.95125 14.956 4.69795L14.9158 8.43108C14.9077 9.17777 14.9037 9.55112 14.7553 9.83475C14.6248 10.0842 14.4182 10.2863 14.166 10.4114C13.8795 10.5535 13.5067 10.5495 12.7615 10.5415L10.8929 10.5213M6.93619 6.47851L5.06976 6.45841C4.32307 6.45037 3.94944 6.44635 3.66268 6.58859C3.41043 6.71371 3.20443 6.91533 3.0739 7.16482C2.92551 7.44846 2.92149 7.82208 2.91345 8.56878L2.87325 12.3019C2.86521 13.0486 2.86119 13.4217 3.00344 13.7085C3.12856 13.9607 3.33017 14.1671 3.57967 14.2976C3.86302 14.4459 4.23619 14.4499 4.98143 14.4579L8.71897 14.4982C9.46421 14.5062 9.83686 14.5102 10.1233 14.3681C10.3756 14.243 10.582 14.0408 10.7125 13.7913C10.8607 13.508 10.8647 13.1352 10.8728 12.39L10.8929 10.5213M6.93619 6.47851L8.80288 6.49861C9.54957 6.50665 9.92272 6.51067 10.2064 6.65906C10.4558 6.78958 10.6578 6.99559 10.7829 7.24784C10.9251 7.53432 10.921 7.9075 10.913 8.65275L10.8929 10.5213"
                                  stroke="#77868B"
                                  stroke-width="1.5"
                                  stroke-linecap="round"
                                  stroke-linejoin="round"
                                />
                              </svg>
                              {copy && <p className="copy-text">Copied</p>}
                            </span>
                          </CopyToClipboard>
                        )}
                      </>
                    )}
                  </h6>
                </div>
              </div>
            </div>

            <div className="innerdashboardbox">
              <div className="innerdashboardboxupper">
                <img
                  src="\assets\dashboardassets\cardthree.svg"
                  alt="dashboardboximg"
                  className="dashboardboximg"
                />
                <div className="dashboardboxtexts">
                  <p className="dashboardparatopbox">My Earning</p>
                  {usdPrice &&
                  purchasesAndEarnings?.length > 0 ? (
                    <h6 className="dashboardheadbox">
                      {purchasesAndEarnings?.length > 0
                        ? "~$" +
                          // parseInt(
                            calculateMyEarningsOverall()
                          // ).toLocaleString(
                          //   "en-US"
                          // )
                        : 0}{" "}
                      <span className={lec > 0 ? "greentext" : "redtext"}>
                        {lec ? lec.toFixed(1) + "% " : ""}
                      </span>
                    </h6>
                  ) : (
                    <h6>~$0.00 USD</h6>
                  )}
                </div>
              </div>
              <div className="valuemaindiv">
                <Dropdown>
                  <Dropdown.Toggle id="dropdown-basic">
                    <img
                      src="\assets\dashboardassets\Caret_Down_MD.svg"
                      alt="arrowimg"
                      className="arrowimg"
                    />
                  </Dropdown.Toggle>

                  <Dropdown.Menu>
                    <div className="teamsdrops">
                      {tokens.map((token) => (
                        <div key={token} className="innerteamdrop">
                          <p className="teamdroppara">{token}</p>
                          <h6 className="teamdrophead">
                            {(
                              purchasesAndEarnings?.find(
                                (item) => item?._id?.tokenSelected === token
                              )?.totalLeaderEarnings || 0
                            ).toFixed(5)}
                          </h6>
                        </div>
                      ))}
                    </div>
                  </Dropdown.Menu>
                </Dropdown>
              </div>
            </div>

            <div className="innerdashboardbox">
              <div className="innerdashboardboxupper">
                <img
                  src="\assets\dashboardassets\cardone.svg"
                  alt="dashboardboximg"
                  className="dashboardboximg"
                />
                <div className="dashboardboxtexts">
                  <p className="dashboardparatopbox">Total Purchases</p>
{console.log(purchasesAndEarnings,usdPrice, 'purchasesAndEarnings')}
                  <h6 className="dashboardheadbox">
                    {(usdPrice &&  purchasesAndEarnings?.length > 0)
                      ? "~$" +
                        // parseInt(
                          calculateTotalPurchasesOverall()
                        // ).toLocaleString("en-US")
                      : 0}{" "}
                    <span className={pmc > 0 ? "greentext" : "redtext"}>
                      {pmc ? pmc.toFixed(1) + "% " : ""}
                    </span>
                  </h6>
                </div>
              </div>
              <div className="valuemaindiv">
                <Dropdown>
                  <Dropdown.Toggle id="dropdown-basic">
                    <img
                      src="\assets\dashboardassets\Caret_Down_MD.svg"
                      alt="arrowimg"
                      className="arrowimg"
                    />
                  </Dropdown.Toggle>

                  <Dropdown.Menu>
                    <div className="teamsdrops">
                      {tokens.map((token) => (
                        <div key={token} className="innerteamdrop">
                          <p className="teamdroppara">{token}</p>
                          <h6 className="teamdrophead">
                            {(
                              purchasesAndEarnings?.find(
                                (item) => item?._id?.tokenSelected === token
                              )?.totalPurchase || 0
                            ).toFixed(5)}
                          </h6>
                        </div>
                      ))}
                    </div>
                  </Dropdown.Menu>
                </Dropdown>
              </div>
            </div>

            <div className="innerdashboardbox">
              <div className="innerdashboardboxupper">
                <img
                  src="\assets\dashboardassets\cardtwo.svg"
                  alt="dashboardboximg"
                  className="dashboardboximg"
                />
                <div className="dashboardboxtexts">
                  <p className="dashboardparatopbox">Number of Purchases</p>

                  <h6 className="dashboardheadbox">
                    {tokenNftStats?.totalPurchases || 0}
                    <span className={pc > 0 ? "greentext" : "redtext"}>
                      {pc ? pc.toFixed(1) + "% " : ""}
                    </span>
                  </h6>
                </div>
              </div>
            </div>

            <div className="innerdashboardbox">
              <div className="innerdashboardboxupper">
                <img
                  src="\assets\dashboardassets\cardfour.svg"
                  alt="dashboardboximg"
                  className="dashboardboximg"
                />
                <div className="dashboardboxtexts">
                  <p className="dashboardparatopbox">My Team</p>

                  {user?.role == "mini_agent" ? (
                    <h6 className="dashboardheadbox">
                      0{/* <span className={"redtext"}>0</span> */}
                    </h6>
                  ) : (
                    <h6 className="dashboardheadbox">
                      {(tokenNftStats?.leaders || 0) +
                        (tokenNftStats?.gods || 0) +
                        (tokenNftStats?.megas || 0) +
                        (tokenNftStats?.miniLeaders || 0) +
                        (tokenNftStats?.supers || 0)}
                      <span className={lc > 0 ? "greentext" : "redtext"}>
                        {lc ? lc.toFixed(1) + "% " : ""}
                      </span>
                    </h6>
                  )}
                </div>
              </div>
              <div className="valuemaindiv">
                {user?.role === "god_agent" && (
                  <>
                    <div className="valuemain">
                      <span className="valueline"></span>
                      <p className="valuepara">{tokenNftStats?.megas} Mega</p>
                    </div>
                    <div className="valuemain">
                      <span className="valueline"></span>
                      <p className="valuepara">{tokenNftStats?.supers} Super</p>
                    </div>
                    <div className="valuemain">
                      <span className="valueline"></span>
                      <p className="valuepara">
                        {tokenNftStats?.leaders} Leader
                      </p>
                    </div>
                    <div className="valuemain">
                      <span className="valueline"></span>
                      <p className="valuepara">
                        {tokenNftStats?.miniLeaders} Ambassadors
                      </p>
                    </div>
                  </>
                )}
                {user?.role === "mega_agent" && (
                  <>
                    <div className="valuemain">
                      <span className="valueline"></span>
                      <p className="valuepara">{tokenNftStats?.supers} Super</p>
                    </div>
                    <div className="valuemain">
                      <span className="valueline"></span>
                      <p className="valuepara">
                        {tokenNftStats?.leaders} Leader
                      </p>
                    </div>
                    <div className="valuemain">
                      <span className="valueline"></span>
                      <p className="valuepara">
                        {tokenNftStats?.miniLeaders} Ambassadors
                      </p>
                    </div>
                  </>
                )}
                {user?.role === "super_agent" && (
                  <>
                    <div className="valuemain">
                      <span className="valueline"></span>
                      <p className="valuepara">
                        {tokenNftStats?.leaders} Leader
                      </p>
                    </div>
                    <div className="valuemain">
                      <span className="valueline"></span>
                      <p className="valuepara">
                        {tokenNftStats?.miniLeaders} Ambassadors
                      </p>
                    </div>
                  </>
                )}
                {user?.role === "agent" && (
                  <>
                    <div className="valuemain">
                      <span className="valueline"></span>
                      <p className="valuepara">
                        {tokenNftStats?.miniLeaders} Ambassadors
                      </p>
                    </div>
                  </>
                )}

                {user?.role !== "mini_agent" && (
                  <Dropdown>
                    <Dropdown.Toggle id="dropdown-basic">
                      <img
                        src="\assets\dashboardassets\Caret_Down_MD.svg"
                        alt="arrowimg"
                        className="arrowimg"
                      />
                    </Dropdown.Toggle>

                    <Dropdown.Menu>
                      {user?.role === "admin" && (
                        <div className="teamsdrops">
                          <div className="innerteamdrop">
                            <p className="teamdroppara">God</p>
                            <h6 className="teamdrophead">
                              {tokenNftStats?.godAgents}
                            </h6>
                          </div>
                          <div className="innerteamdrop">
                            <p className="teamdroppara">Mega</p>
                            <h6 className="teamdrophead">
                              {tokenNftStats?.megaAgents}
                            </h6>
                          </div>
                          <div className="innerteamdrop">
                            <p className="teamdroppara">Super</p>
                            <h6 className="teamdrophead">
                              {" "}
                              {tokenNftStats?.superAgents}
                            </h6>
                          </div>
                          <div className="innerteamdrop">
                            <p className="teamdroppara">Leader</p>
                            <h6 className="teamdrophead">
                              {tokenNftStats?.agents}
                            </h6>
                          </div>
                          <div className="innerteamdrop">
                            <p className="teamdroppara">Ambassador</p>
                            <h6 className="teamdrophead">
                              {tokenNftStats?.miniAgents}
                            </h6>
                          </div>
                        </div>
                      )}
                      {user?.role === "god_agent" && (
                        <div className="teamsdrops">
                          <div className="innerteamdrop">
                            <p className="teamdroppara">Mega</p>
                            <h6 className="teamdrophead">
                              {tokenNftStats?.megas}
                            </h6>
                          </div>
                          <div className="innerteamdrop">
                            <p className="teamdroppara">Super</p>
                            <h6 className="teamdrophead">
                              {" "}
                              {tokenNftStats?.supers}
                            </h6>
                          </div>
                          <div className="innerteamdrop">
                            <p className="teamdroppara">Leader</p>
                            <h6 className="teamdrophead">
                              {tokenNftStats?.leaders}
                            </h6>
                          </div>
                          <div className="innerteamdrop">
                            <p className="teamdroppara">Ambassador</p>
                            <h6 className="teamdrophead">
                              {tokenNftStats?.miniLeaders}
                            </h6>
                          </div>
                        </div>
                      )}
                      {user?.role === "mega_agent" && (
                        <div className="teamsdrops">
                          <div className="innerteamdrop">
                            <p className="teamdroppara">Super</p>
                            <h6 className="teamdrophead">
                              {" "}
                              {tokenNftStats?.supers}
                            </h6>
                          </div>
                          <div className="innerteamdrop">
                            <p className="teamdroppara">Leader</p>
                            <h6 className="teamdrophead">
                              {tokenNftStats?.leaders}
                            </h6>
                          </div>
                          <div className="innerteamdrop">
                            <p className="teamdroppara">Ambassador</p>
                            <h6 className="teamdrophead">
                              {tokenNftStats?.miniLeaders}
                            </h6>
                          </div>
                        </div>
                      )}
                      {user?.role === "super_agent" && (
                        <div className="teamsdrops">
                          <div className="innerteamdrop">
                            <p className="teamdroppara">Leader</p>
                            <h6 className="teamdrophead">
                              {tokenNftStats?.leaders}
                            </h6>
                          </div>
                          <div className="innerteamdrop">
                            <p className="teamdroppara">Ambassador</p>
                            <h6 className="teamdrophead">
                              {tokenNftStats?.miniLeaders}
                            </h6>
                          </div>
                        </div>
                      )}
                      {user?.role === "agent" && (
                        <div className="teamsdrops">
                          <div className="innerteamdrop">
                            <p className="teamdroppara">Ambassador</p>
                            <h6 className="teamdrophead">
                              {tokenNftStats?.miniLeaders}
                            </h6>
                          </div>
                        </div>
                      )}
                    </Dropdown.Menu>
                  </Dropdown>
                )}
              </div>
            </div>

            <div className="innerdashboardbox">
              <div className="innerdashboardboxupper">
                <img
                  src="\assets\dashboardassets\cardfive.svg"
                  alt="dashboardboximg"
                  className="dashboardboximg"
                />
                <div className="dashboardboxtexts">
                  <p className="dashboardparatopbox">Avg. Team earning</p>

                  <h6 className="dashboardheadbox">
                    {purchasesAndEarnings?.length > 0
                      ? "~$" +
                        parseFloat(
                          (
                            (usdPrice *
                              (purchasesAndEarnings &&
                              purchasesAndEarnings?.length > 0 &&
                              purchasesAndEarnings[0]?._id?.tokenSelected ==
                                "ETH"
                                ? purchasesAndEarnings[0]?.totalLeaderEarnings
                                : purchasesAndEarnings &&
                                  purchasesAndEarnings?.length > 0 &&
                                  purchasesAndEarnings[1]?._id?.tokenSelected ==
                                    "ETH"
                                ? purchasesAndEarnings[1]?.totalLeaderEarnings
                                : purchasesAndEarnings &&
                                  purchasesAndEarnings?.length > 0 &&
                                  purchasesAndEarnings[2]?._id?.tokenSelected ==
                                    "ETH"
                                ? purchasesAndEarnings[2]?.totalLeaderEarnings
                                : purchasesAndEarnings &&
                                  purchasesAndEarnings?.length > 0 &&
                                  purchasesAndEarnings[3]?._id?.tokenSelected ==
                                    "ETH"
                                ? purchasesAndEarnings[3]?.totalLeaderEarnings
                                : purchasesAndEarnings &&
                                  purchasesAndEarnings?.length > 0 &&
                                  purchasesAndEarnings[4]?._id?.tokenSelected ==
                                    "ETH"
                                ? purchasesAndEarnings[4]?.totalLeaderEarnings
                                : 0) +
                              (purchasesAndEarnings &&
                              purchasesAndEarnings?.length > 0 &&
                              purchasesAndEarnings[0]?._id?.tokenSelected ==
                                "USDT"
                                ? purchasesAndEarnings[0]?.totalLeaderEarnings
                                : purchasesAndEarnings &&
                                  purchasesAndEarnings?.length > 0 &&
                                  purchasesAndEarnings[1]?._id?.tokenSelected ==
                                    "USDT"
                                ? purchasesAndEarnings[1]?.totalLeaderEarnings
                                : purchasesAndEarnings &&
                                  purchasesAndEarnings?.length > 0 &&
                                  purchasesAndEarnings[2]?._id?.tokenSelected ==
                                    "USDT"
                                ? purchasesAndEarnings[2]?.totalLeaderEarnings
                                : purchasesAndEarnings &&
                                  purchasesAndEarnings?.length > 0 &&
                                  purchasesAndEarnings[3]?._id?.tokenSelected ==
                                    "USDT"
                                ? purchasesAndEarnings[3]?.totalLeaderEarnings
                                : purchasesAndEarnings &&
                                  purchasesAndEarnings?.length > 0 &&
                                  purchasesAndEarnings[4]?._id?.tokenSelected ==
                                    "USDT"
                                ? purchasesAndEarnings[4]?.totalLeaderEarnings
                                : 0) +
                              tomiPrice *
                                (purchasesAndEarnings &&
                                purchasesAndEarnings?.length > 0 &&
                                purchasesAndEarnings[0]?._id?.tokenSelected ==
                                  "TOMI"
                                  ? purchasesAndEarnings[0]?.totalLeaderEarnings
                                  : purchasesAndEarnings &&
                                    purchasesAndEarnings?.length > 0 &&
                                    purchasesAndEarnings[1]?._id
                                      ?.tokenSelected == "TOMI"
                                  ? purchasesAndEarnings[1]?.totalLeaderEarnings
                                  : purchasesAndEarnings &&
                                    purchasesAndEarnings?.length > 0 &&
                                    purchasesAndEarnings[2]?._id
                                      ?.tokenSelected == "TOMI"
                                  ? purchasesAndEarnings[2]?.totalLeaderEarnings
                                  : purchasesAndEarnings &&
                                    purchasesAndEarnings?.length > 0 &&
                                    purchasesAndEarnings[3]?._id
                                      ?.tokenSelected == "TOMI"
                                  ? purchasesAndEarnings[3]?.totalLeaderEarnings
                                  : purchasesAndEarnings &&
                                    purchasesAndEarnings?.length > 0 &&
                                    purchasesAndEarnings[4]?._id
                                      ?.tokenSelected == "TOMI"
                                  ? purchasesAndEarnings[4]?.totalLeaderEarnings
                                  : 0) +
                              btcPrice *
                                (purchasesAndEarnings &&
                                purchasesAndEarnings?.length > 0 &&
                                purchasesAndEarnings[0]?._id?.tokenSelected ==
                                  "WBTC"
                                  ? purchasesAndEarnings[0]?.totalLeaderEarnings
                                  : purchasesAndEarnings &&
                                    purchasesAndEarnings?.length > 0 &&
                                    purchasesAndEarnings[1]?._id
                                      ?.tokenSelected == "WBTC"
                                  ? purchasesAndEarnings[1]?.totalLeaderEarnings
                                  : purchasesAndEarnings &&
                                    purchasesAndEarnings?.length > 0 &&
                                    purchasesAndEarnings[2]?._id
                                      ?.tokenSelected == "WBTC"
                                  ? purchasesAndEarnings[2]?.totalLeaderEarnings
                                  : purchasesAndEarnings &&
                                    purchasesAndEarnings?.length > 0 &&
                                    purchasesAndEarnings[3]?._id
                                      ?.tokenSelected == "WBTC"
                                  ? purchasesAndEarnings[3]?.totalLeaderEarnings
                                  : purchasesAndEarnings &&
                                    purchasesAndEarnings?.length > 0 &&
                                    purchasesAndEarnings[4]?._id
                                      ?.tokenSelected == "WBTC"
                                  ? purchasesAndEarnings[4]?.totalLeaderEarnings
                                  : 0) +
                              (purchasesAndEarnings &&
                              purchasesAndEarnings?.length > 0 &&
                              purchasesAndEarnings[0]?._id?.tokenSelected ==
                                "USDC"
                                ? purchasesAndEarnings[0]?.totalLeaderEarnings
                                : purchasesAndEarnings &&
                                  purchasesAndEarnings?.length > 0 &&
                                  purchasesAndEarnings[1]?._id?.tokenSelected ==
                                    "USDC"
                                ? purchasesAndEarnings[1]?.totalLeaderEarnings
                                : purchasesAndEarnings &&
                                  purchasesAndEarnings?.length > 0 &&
                                  purchasesAndEarnings[2]?._id?.tokenSelected ==
                                    "USDC"
                                ? purchasesAndEarnings[2]?.totalLeaderEarnings
                                : purchasesAndEarnings &&
                                  purchasesAndEarnings?.length > 0 &&
                                  purchasesAndEarnings[3]?._id?.tokenSelected ==
                                    "USDC"
                                ? purchasesAndEarnings[3]?.totalLeaderEarnings
                                : purchasesAndEarnings &&
                                  purchasesAndEarnings?.length > 0 &&
                                  purchasesAndEarnings[4]?._id?.tokenSelected ==
                                    "USDC"
                                ? purchasesAndEarnings[4]?.totalLeaderEarnings
                                : 0) +
                              dopPrice *
                                (purchasesAndEarnings &&
                                purchasesAndEarnings?.length > 0 &&
                                purchasesAndEarnings[0]?._id?.tokenSelected ==
                                  "DOP"
                                  ? purchasesAndEarnings[0]?.totalLeaderEarnings
                                  : purchasesAndEarnings &&
                                    purchasesAndEarnings?.length > 0 &&
                                    purchasesAndEarnings[1]?._id
                                      ?.tokenSelected == "DOP"
                                  ? purchasesAndEarnings[1]?.totalLeaderEarnings
                                  : purchasesAndEarnings &&
                                    purchasesAndEarnings?.length > 0 &&
                                    purchasesAndEarnings[2]?._id
                                      ?.tokenSelected == "DOP"
                                  ? purchasesAndEarnings[2]?.totalLeaderEarnings
                                  : purchasesAndEarnings &&
                                    purchasesAndEarnings?.length > 0 &&
                                    purchasesAndEarnings[3]?._id
                                      ?.tokenSelected == "DOP"
                                  ? purchasesAndEarnings[3]?.totalLeaderEarnings
                                  : purchasesAndEarnings &&
                                    purchasesAndEarnings?.length > 0 &&
                                    purchasesAndEarnings[4]?._id
                                      ?.tokenSelected == "DOP"
                                  ? purchasesAndEarnings[4]?.totalLeaderEarnings
                                  : 0) +
                              pepePrice *
                                (purchasesAndEarnings &&
                                purchasesAndEarnings?.length > 0 &&
                                purchasesAndEarnings[0]?._id?.tokenSelected ==
                                  "PEPE"
                                  ? purchasesAndEarnings[0]?.totalLeaderEarnings
                                  : purchasesAndEarnings &&
                                    purchasesAndEarnings?.length > 0 &&
                                    purchasesAndEarnings[1]?._id
                                      ?.tokenSelected == "PEPE"
                                  ? purchasesAndEarnings[1]?.totalLeaderEarnings
                                  : purchasesAndEarnings &&
                                    purchasesAndEarnings?.length > 0 &&
                                    purchasesAndEarnings[2]?._id
                                      ?.tokenSelected == "PEPE"
                                  ? purchasesAndEarnings[2]?.totalLeaderEarnings
                                  : purchasesAndEarnings &&
                                    purchasesAndEarnings?.length > 0 &&
                                    purchasesAndEarnings[3]?._id
                                      ?.tokenSelected == "PEPE"
                                  ? purchasesAndEarnings[3]?.totalLeaderEarnings
                                  : purchasesAndEarnings &&
                                    purchasesAndEarnings?.length > 0 &&
                                    purchasesAndEarnings[4]?._id
                                      ?.tokenSelected == "PEPE"
                                  ? purchasesAndEarnings[4]?.totalLeaderEarnings
                                  : 0) +
                              linkPrice *
                                (purchasesAndEarnings &&
                                purchasesAndEarnings?.length > 0 &&
                                purchasesAndEarnings[0]?._id?.tokenSelected ==
                                  "LINK"
                                  ? purchasesAndEarnings[0]?.totalLeaderEarnings
                                  : purchasesAndEarnings &&
                                    purchasesAndEarnings?.length > 0 &&
                                    purchasesAndEarnings[1]?._id
                                      ?.tokenSelected == "LINK"
                                  ? purchasesAndEarnings[1]?.totalLeaderEarnings
                                  : purchasesAndEarnings &&
                                    purchasesAndEarnings?.length > 0 &&
                                    purchasesAndEarnings[2]?._id
                                      ?.tokenSelected == "LINK"
                                  ? purchasesAndEarnings[2]?.totalLeaderEarnings
                                  : purchasesAndEarnings &&
                                    purchasesAndEarnings?.length > 0 &&
                                    purchasesAndEarnings[3]?._id
                                      ?.tokenSelected == "LINK"
                                  ? purchasesAndEarnings[3]?.totalLeaderEarnings
                                  : purchasesAndEarnings &&
                                    purchasesAndEarnings?.length > 0 &&
                                    purchasesAndEarnings[4]?._id
                                      ?.tokenSelected == "LINK"
                                  ? purchasesAndEarnings[4]?.totalLeaderEarnings
                                  : 0) +
                              uniPrice *
                                (purchasesAndEarnings &&
                                purchasesAndEarnings?.length > 0 &&
                                purchasesAndEarnings[0]?._id?.tokenSelected ==
                                  "UNI"
                                  ? purchasesAndEarnings[0]?.totalLeaderEarnings
                                  : purchasesAndEarnings &&
                                    purchasesAndEarnings?.length > 0 &&
                                    purchasesAndEarnings[1]?._id
                                      ?.tokenSelected == "UNI"
                                  ? purchasesAndEarnings[1]?.totalLeaderEarnings
                                  : purchasesAndEarnings &&
                                    purchasesAndEarnings?.length > 0 &&
                                    purchasesAndEarnings[2]?._id
                                      ?.tokenSelected == "UNI"
                                  ? purchasesAndEarnings[2]?.totalLeaderEarnings
                                  : purchasesAndEarnings &&
                                    purchasesAndEarnings?.length > 0 &&
                                    purchasesAndEarnings[3]?._id
                                      ?.tokenSelected == "UNI"
                                  ? purchasesAndEarnings[3]?.totalLeaderEarnings
                                  : purchasesAndEarnings &&
                                    purchasesAndEarnings?.length > 0 &&
                                    purchasesAndEarnings[4]?._id
                                      ?.tokenSelected == "UNI"
                                  ? purchasesAndEarnings[4]?.totalLeaderEarnings
                                  : 0) +
                              gemsPrice *
                                (purchasesAndEarnings &&
                                purchasesAndEarnings?.length > 0 &&
                                purchasesAndEarnings[0]?._id?.tokenSelected ==
                                  "GEMS"
                                  ? purchasesAndEarnings[0]?.totalLeaderEarnings
                                  : purchasesAndEarnings &&
                                    purchasesAndEarnings?.length > 0 &&
                                    purchasesAndEarnings[1]?._id
                                      ?.tokenSelected == "GEMS"
                                  ? purchasesAndEarnings[1]?.totalLeaderEarnings
                                  : purchasesAndEarnings &&
                                    purchasesAndEarnings?.length > 0 &&
                                    purchasesAndEarnings[2]?._id
                                      ?.tokenSelected == "GEMS"
                                  ? purchasesAndEarnings[2]?.totalLeaderEarnings
                                  : purchasesAndEarnings &&
                                    purchasesAndEarnings?.length > 0 &&
                                    purchasesAndEarnings[3]?._id
                                      ?.tokenSelected == "GEMS"
                                  ? purchasesAndEarnings[3]?.totalLeaderEarnings
                                  : purchasesAndEarnings &&
                                    purchasesAndEarnings?.length > 0 &&
                                    purchasesAndEarnings[4]?._id
                                      ?.tokenSelected == "GEMS"
                                  ? purchasesAndEarnings[4]?.totalLeaderEarnings
                                  : 0)) /
                            ((tokenNftStats?.leaders || 0) +
                              (tokenNftStats?.gods || 0) +
                              (tokenNftStats?.megas || 0) +
                              (tokenNftStats?.miniLeaders || 0) +
                              (tokenNftStats?.supers || 0) || 1)
                          )?.toFixed(4)
                        ).toLocaleString("en-US")
                      : 0}{" "}
                    <span className={lec > 0 ? "greentext" : "redtext"}>
                      {lec ? lec.toFixed(1) + "% " : ""}
                    </span>
                  </h6>
                </div>
              </div>
            </div>
          </div>
          <div className="tabsmain">
            <Nav variant="pills" activeKey={activeTab} onSelect={handleSelect}>
              <Nav.Item>
                <Nav.Link eventKey="link-1">Latest Transactions</Nav.Link>
              </Nav.Item>
              {!(user?.role === "mini_agent") && (
                <Nav.Item>
                  <Nav.Link eventKey="link-2">Leaders</Nav.Link>
                </Nav.Item>
              )}
            </Nav>
            {/* <div className="searchinputmain">
              <input
                type="text"
                placeholder="Search..."
                className="searchinput"
              />
              <img
                src="\assets\dashboardassets\search-normal.svg"
                alt="searchinputimg"
                className="searchinputimg"
              />
            </div> */}
          </div>

          {activeTab === "link-1" && (
            <>
              <div className="hideabtn">
                <Datatable
                  page={page}
                  handlePageChange={handlePageChange}
                  pageCount={pageCount}
                  transactions={transactions}
                  transactionApiCalled={transactionApiCalled}
                  dashboarddetail={true}
                  setOrderField={setOrderField}
                  setOrderDirection={setOrderDirection}
                  orderField={orderField}
                  orderDirection={orderDirection}
                />
              </div>
            </>
          )}

          {activeTab === "link-2" && (
            <>
              <LeadersDatatable
                btcPrice={btcPrice}
                usdPrice={usdPrice}
                tomiPrice={tomiPrice}
                GetAllRounds={GetAgents}
                pageCount={pageCount}
                GetAgents={GetAgents}
                page={page}
                offset={offset}
                setOffset={setOffset}
                limit={limitAgents}
                count={count}
                agents={agents}
                setAgents={setAgents}
                setOrderDirection={setOrderDirection}
                setOrderField={setOrderFieldAgents}
                orderDirection={orderDirection}
                orderField={orderFieldAgents}
                handlePageChange={handlePageChange}
                pagination={true}
                leadersLoader={leadersLoader}
                MyTeamOnDashboard={true}
              />
              {/* <section className="mainproject">
                <div className="main-card">
                  <div className="table-responsive">
                    <table classNyame="table">
                      <thead className="tblheadss">
                        <tr>
                          <th>
                            name{" "}
                            <img
                              src="\Group120.svg"
                              alt="img"
                              className="img-fluid"
                            />
                          </th>
                          <th>
                            Code{" "}
                            <img
                              src="\Group120.svg"
                              alt="img"
                              className="img-fluid"
                            />
                          </th>
                          <th>
                            Wallet Address{" "}
                            <img
                              src="\Group120.svg"
                              alt="img"
                              className="img-fluid"
                            />
                          </th>
                          <th>
                            Email{" "}
                            <img
                              src="\Group120.svg"
                              alt="img"
                              className="img-fluid"
                            />
                          </th>
                          <th>
                            Total Sale{" "}
                            <img
                              src="\Group120.svg"
                              alt="img"
                              className="img-fluid"
                            />
                          </th>
                          <th>
                            Agent Earnings{" "}
                            <img
                              src="\Group120.svg"
                              alt="img"
                              className="img-fluid"
                            />
                          </th>
                          <th>
                            commision %{" "}
                            <img
                              src="\Group120.svg"
                              alt="img"
                              className="img-fluid"
                            />
                          </th>
                          <th>Action</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td>
                            <div className="parenttbl">
                              <div className="left">
                                <img
                                  src="\assets\dashboardassets\profiletableimg.svg"
                                  alt="img"
                                  className="img-fluid"
                                />
                              </div>
                              <div className="right">
                                <h6>John Doe</h6>
                                <p>Ambassador</p>
                              </div>
                            </div>
                          </td>
                          <td>
                            <p className="para">
                              635984{" "}
                              <img
                                src="\assets\dashboardassets\Copy.svg"
                                alt="img"
                                className="copy"
                              />
                            </p>
                          </td>
                          <td>
                            <p className="para">
                              0x97E6...879A{" "}
                              <img
                                src="\assets\dashboardassets\Copy.svg"
                                alt="img"
                                className="copy"
                              />
                            </p>
                          </td>
                          <td>john@gmail.com</td>
                          <td>
                            <h6>$10</h6>
                            <p>(1.5 ETH + 3.3 USDT)</p>
                          </td>
                          <td>
                            <h6>$500</h6>
                            <p>(1.5 ETH + 3.3 USDT)</p>
                          </td>
                          <td>
                            {" "}
                            <p className="para">2.5%</p>
                          </td>
                          <td>
                            <img
                              src="\more.png"
                              alt="img"
                              className="img-fluid"
                            />
                          </td>
                        </tr>
                        <tr>
                          <td>
                            <div className="parenttbl">
                              <div className="left">
                                <img
                                  src="\assets\dashboardassets\profiletableimg.svg"
                                  alt="img"
                                  className="img-fluid"
                                />
                              </div>
                              <div className="right">
                                <h6>John Doe</h6>
                                <p>Ambassador</p>
                              </div>
                            </div>
                          </td>
                          <td>
                            <p className="para">
                              635984{" "}
                              <img
                                src="\assets\dashboardassets\Copy.svg"
                                alt="img"
                                className="copy"
                              />
                            </p>
                          </td>
                          <td>
                            <p className="para">
                              0x97E6...879A{" "}
                              <img
                                src="\assets\dashboardassets\Copy.svg"
                                alt="img"
                                className="copy"
                              />
                            </p>
                          </td>
                          <td>john@gmail.com</td>
                          <td>
                            <h6>$10</h6>
                            <p>(1.5 ETH + 3.3 USDT)</p>
                          </td>
                          <td>
                            <h6>$500</h6>
                            <p>(1.5 ETH + 3.3 USDT)</p>
                          </td>
                          <td>
                            {" "}
                            <p className="para">2.5%</p>
                          </td>
                          <td>
                            <img
                              src="\more.png"
                              alt="img"
                              className="img-fluid"
                            />
                          </td>
                        </tr>
                        <tr>
                          <td>
                            <div className="parenttbl">
                              <div className="left">
                                <img
                                  src="\assets\dashboardassets\profiletableimg.svg"
                                  alt="img"
                                  className="img-fluid"
                                />
                              </div>
                              <div className="right">
                                <h6>John Doe</h6>
                                <p>Ambassador</p>
                              </div>
                            </div>
                          </td>
                          <td>
                            <p className="para">
                              635984{" "}
                              <img
                                src="\assets\dashboardassets\Copy.svg"
                                alt="img"
                                className="copy"
                              />
                            </p>
                          </td>
                          <td>
                            <p className="para">
                              0x97E6...879A{" "}
                              <img
                                src="\assets\dashboardassets\Copy.svg"
                                alt="img"
                                className="copy"
                              />
                            </p>
                          </td>
                          <td>john@gmail.com</td>
                          <td>
                            <h6>$10</h6>
                            <p>(1.5 ETH + 3.3 USDT)</p>
                          </td>
                          <td>
                            <h6>$500</h6>
                            <p>(1.5 ETH + 3.3 USDT)</p>
                          </td>
                          <td>
                            {" "}
                            <p className="para">2.5%</p>
                          </td>
                          <td>
                            <img
                              src="\more.png"
                              alt="img"
                              className="img-fluid"
                            />
                          </td>
                        </tr>
                        <tr>
                          <td>
                            <div className="parenttbl">
                              <div className="left">
                                <img
                                  src="\assets\dashboardassets\profiletableimg.svg"
                                  alt="img"
                                  className="img-fluid"
                                />
                              </div>
                              <div className="right">
                                <h6>John Doe</h6>
                                <p>Ambassador</p>
                              </div>
                            </div>
                          </td>
                          <td>
                            <p className="para">
                              635984{" "}
                              <img
                                src="\assets\dashboardassets\Copy.svg"
                                alt="img"
                                className="copy"
                              />
                            </p>
                          </td>
                          <td>
                            <p className="para">
                              0x97E6...879A{" "}
                              <img
                                src="\assets\dashboardassets\Copy.svg"
                                alt="img"
                                className="copy"
                              />
                            </p>
                          </td>
                          <td>john@gmail.com</td>
                          <td>
                            <h6>$10</h6>
                            <p>(1.5 ETH + 3.3 USDT)</p>
                          </td>
                          <td>
                            <h6>$500</h6>
                            <p>(1.5 ETH + 3.3 USDT)</p>
                          </td>
                          <td>
                            {" "}
                            <p className="para">2.5%</p>
                          </td>
                          <td>
                            <img
                              src="\more.png"
                              alt="img"
                              className="img-fluid"
                            />
                          </td>
                        </tr>
                        <tr>
                          <td>
                            <div className="parenttbl">
                              <div className="left">
                                <img
                                  src="\assets\dashboardassets\profiletableimg.svg"
                                  alt="img"
                                  className="img-fluid"
                                />
                              </div>
                              <div className="right">
                                <h6>John Doe</h6>
                                <p>Ambassador</p>
                              </div>
                            </div>
                          </td>
                          <td>
                            <p className="para">
                              635984{" "}
                              <img
                                src="\assets\dashboardassets\Copy.svg"
                                alt="img"
                                className="copy"
                              />
                            </p>
                          </td>
                          <td>
                            <p className="para">
                              0x97E6...879A{" "}
                              <img
                                src="\assets\dashboardassets\Copy.svg"
                                alt="img"
                                className="copy"
                              />
                            </p>
                          </td>
                          <td>john@gmail.com</td>
                          <td>
                            <h6>$10</h6>
                            <p>(1.5 ETH + 3.3 USDT)</p>
                          </td>
                          <td>
                            <h6>$500</h6>
                            <p>(1.5 ETH + 3.3 USDT)</p>
                          </td>
                          <td>
                            {" "}
                            <p className="para">2.5%</p>
                          </td>
                          <td>
                            <img
                              src="\more.png"
                              alt="img"
                              className="img-fluid"
                            />
                          </td>
                        </tr>
                        <tr>
                          <td>
                            <div className="parenttbl">
                              <div className="left">
                                <img
                                  src="\assets\dashboardassets\profiletableimg.svg"
                                  alt="img"
                                  className="img-fluid"
                                />
                              </div>
                              <div className="right">
                                <h6>John Doe</h6>
                                <p>Ambassador</p>
                              </div>
                            </div>
                          </td>
                          <td>
                            <p className="para">
                              635984{" "}
                              <img
                                src="\assets\dashboardassets\Copy.svg"
                                alt="img"
                                className="copy"
                              />
                            </p>
                          </td>
                          <td>
                            <p className="para">
                              0x97E6...879A{" "}
                              <img
                                src="\assets\dashboardassets\Copy.svg"
                                alt="img"
                                className="copy"
                              />
                            </p>
                          </td>
                          <td>john@gmail.com</td>
                          <td>
                            <h6>$10</h6>
                            <p>(1.5 ETH + 3.3 USDT)</p>
                          </td>
                          <td>
                            <h6>$500</h6>
                            <p>(1.5 ETH + 3.3 USDT)</p>
                          </td>
                          <td>
                            {" "}
                            <p className="para">2.5%</p>
                          </td>
                          <td>
                            <img
                              src="\more.png"
                              alt="img"
                              className="img-fluid"
                            />
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                  <div className="footer-content">
                    <div className="left-f">
                      <h6>SHOWING 1-10 OF 145</h6>
                    </div>
                    <div className="right-f">
                      <nav aria-label="Page navigation example">
                        <ul class="pagination">
                          <li class="page-item">
                            <a class="page-link" href="#">
                              {"<"}
                            </a>
                          </li>
                          <li class="page-item">
                            <a class="page-link active" href="#">
                              1
                            </a>
                          </li>
                          <li class="page-item">
                            <a class="page-link" href="#">
                              2
                            </a>
                          </li>
                          <li class="page-item">
                            <a class="page-link" href="#">
                              3
                            </a>
                          </li>
                          <li class="page-item">
                            <a class="page-link" href="#">
                              4
                            </a>
                          </li>
                          <li class="page-item">
                            <a class="page-link" href="#">
                              5
                            </a>
                          </li>
                          <li class="page-item">
                            <a class="page-link" href="#">
                              {">"}
                            </a>
                          </li>
                        </ul>
                      </nav>
                    </div>
                  </div>
                </div>
              </section> */}
            </>
          )}
        </div>
      </section>

      <Footerline />

      <Modal show={show} onHide={handleClose} className="leavemodal" centered>
        <Modal.Header closeButton>
          <Modal.Title>Modal heading</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="leavemodalinner">
            <img
              src="\assets\dashboardassets\leaveimg.png"
              alt="modalimg"
              className="modalimg"
            />
            <p className="leavemodalpara">
              Are you sure you want to leave this project
            </p>
          </div>
          <div className="leavemodalbtns">
            <button onClick={handleClose} className="lightbtn">
              Cancel
            </button>
            <button onClick={handleClose} className="redbtn">
              Confirm
            </button>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default Dashboarddetail;
